import type { SVGProps } from 'react';
export const MobileBig = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 32 32" {...props}>
    <path
      fillRule="evenodd"
      d="M11.67 7.4a.73.73 0 0 0-.73.73v.73h10.12v-.73a.73.73 0 0 0-.73-.73zm10.83.73c0-1.16-.95-2.13-2.17-2.13h-8.66c-1.22 0-2.17.97-2.17 2.13v15.74c0 1.16.95 2.13 2.17 2.13h8.66c1.22 0 2.17-.97 2.17-2.13zm-1.44 2.13H10.94v11.48h10.12zm0 12.88H10.94v.73c0 .42.34.73.73.73h8.66c.39 0 .73-.3.73-.73z"
      clipRule="evenodd"
    />
  </svg>
);
